import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type MatchPlanModel from './match-plan';
import { Type } from '@warp-drive/core-types/symbols';

export default class MatchPeriodModel extends Model {
  @attr declare startDate: string;
  @attr declare endDate: string;
  @attr declare periodName: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('match-plan', { async: false, inverse: 'matchPeriods' })
  declare matchPlan: MatchPlanModel;

  [Type] = 'match-period' as const;
}
